
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/photo-to-illustration",
      function () {
        return require("private-next-pages/photo-to-illustration/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/photo-to-illustration"])
      });
    }
  